import { useState } from 'react'
import { useAuthProvider } from 'src/context/AuthProvider'
import useLogger from 'src/context/LoggerProvider/useLogger'

const RevalidateButton = () => {
  const { currentUser } = useAuthProvider()
  const [isLoading, setIsLoading] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const logger = useLogger()

  // Only show for admin users
  if (!currentUser?.isAdmin) {
    return null
  }

  const handleRevalidate = async () => {
    setIsLoading(true)
    setShowSuccess(false)

    try {
      const response = await fetch('/api/revalidate-blogs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        setShowSuccess(true)
        setTimeout(() => {
          setShowSuccess(false)
          window.location.reload()
        }, 500)
      } else {
        logger.error('Failed to revalidate blogs', { response })
      }
    } catch (error) {
      logger.error('Error revalidating blogs:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="fixed right-6 bottom-6 z-50">
      <button
        type="button"
        onClick={handleRevalidate}
        disabled={isLoading}
        className={`
          relative flex size-14 items-center justify-center rounded-full shadow-lg transition-all duration-200
          ease-in-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800
          ${
            isLoading
              ? 'cursor-not-allowed bg-cream-500'
              : showSuccess
                ? 'bg-green-500 hover:bg-green-600'
                : 'bg-blue-500 hover:scale-110 hover:bg-blue-600'
          }
        `}
        title="Revalidate Blogs"
      >
        {isLoading ? (
          <div className="size-6 animate-spin rounded-full border-2 border-ink-100/15 border-t-ink-700"></div>
        ) : showSuccess ? (
          <svg
            className="size-6 text-white-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        ) : (
          <svg
            className="size-6 text-white-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        )}
      </button>

      {showSuccess && (
        <div className="absolute right-0 bottom-16 rounded-lg bg-ink-800 px-3 py-2 text-sm whitespace-nowrap text-white-500 shadow-lg">
          Blogs revalidated successfully!
        </div>
      )}
    </div>
  )
}

export default RevalidateButton
